<template>
    <div class="loan_wrap">
        <div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('预计还款') }}</div>
		</div>
        <form class="form">
            <div class="item">
                <span class="t">
                    {{$t('申请人')}}
                </span>
                <input
                     v-model="ruleForm.name"
                    type="text"
                    class="inp"
                    :placeholder="$t('真实姓名')"
                    readonly
                >
            </div>

            <div class="item">
                <span class="t">
                    {{$t('已贷款天数')}}
                </span>
                <input
                     v-model="ruleForm.days"
                    type="text"
                    class="inp"
                    :placeholder="`1${$t('天')}`"
                    readonly
                >
            </div>
            <div class="item">
                <span class="t">
                    {{$t('还款金额')}}
                </span>
                <input
                     v-model="ruleForm.amount"
                    type="number"
                    class="inp"
                    :placeholder="$t('请输入还款金额')"
                >
            </div>
            <div class="item">
                <span class="t">
                    {{$t('贷款利率')}}
                </span>
                <input
                     v-model="ruleForm.interestRate"
                    type="text"
                    class="inp"
                    placeholder="0%"
                    readonly
                >
            </div>
            <div class="item">
                <span class="t">
                    {{$t('还款方式')}}
                </span>
                <input
                     v-model="ruleForm.loanMethod"
                    type="text"
                    class="inp"
                    :placeholder="$t('账户余额')"
                    readonly
                >
            </div>
        </form>
        <div class="bottom">
            <button  class="button" @click="sellerRegister">
                {{$t('确认还款')}}
            </button>
        </div>
        <div v-show="setPwd" class="real_name_mask">
			<div class="real_box">
				<div class="tit" />
				<p class="tips" style="font-size: 16px; ">
					{{ $t('cash.setPwdFirst') }}
				</p>
				<div class="basic_btn" @click="setIniPwd">
					{{ $t('cash.setNow') }}
				</div>
			</div>
		</div>
        <van-popup v-model="write_psd" closeable close-icon="close" round position="bottom">
			<div class="psw_box">
				<van-password-input :value="psd_val" :mask="true" :focused="showKeyboard"
					@focus="showKeyboard = true" />
				<div class="keybord_box">
					<div class="keybord">
						<div class="key_item" v-for="i in 9" @click="onInput(i)">
							<div class="key_inner">{{ i }}</div>
						</div>
						<div class="key_item no_bg">
							<div class="key_inner"></div>
						</div>
						<div class="key_item" @click="onInput(0)">
							<div class="key_inner">0</div>
						</div>
						<div class="key_item no_bg x" @click="onDelete">
							<div class="key_inner">x</div>
						</div>
					</div>
				</div>
			</div>
		</van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import {
	DropdownMenu,
	DropdownItem,
	Popup,
	PasswordInput,
	NumberKeyboard,
	Icon,
	ActionSheet,
	Toast
} from 'vant';
Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

import footers from '@/components/bsFooter.vue'
export default {
    components:{
        footers
    },
    data() {
        return {
            loanHistory:[],
            showKeyboard: true,
			write_psd: false,
            psd_val:'',
            ruleForm: {
                name:'',            // 借款人姓名 
                card_num :'',       // 身份证号   
                phone:'',           //  联系电话 
                amount:'',           //  借贷金额 
                repayment_day_id:'',    //  还款天数ID
                interestRate:'',
                country:'',
                kyc_front_img:'',   //身份正面
                kyc_reverse_side_img:'',    //反面
                kyc_handheld_img:'',
                days:'',
                loanMethod:"账户余额"
            },
            submitType: 1,
            form: {
				money: '',
				password: '',
				bank_id: 0,
			},
            setPwd:false,
            info:{}
        }
    },
    async created() {
        this.$parent.footer('item', false);
        Fetch("/loan/list").then((r) => {
            this.loanHistory = r.data.list
            let id = this.$route.query.creditId
            this.info = r.data.list.find(x => x.id == id)
            this.ruleForm.name = this.info.name
            this.ruleForm.interestRate = this.info.interest_rate +'%'
            this.ruleForm.days = this.info.repayment_day_text
            this.ruleForm.amount = this.info.repayment_amount
		});      
        Fetch('/user/my_bank').then((r) => {
			this.setPwd = r.data.intPwd;
            if(!this.setPwd){
                this.submitType = 2   
            }
        })
    },
    methods: {
        onInput(key) {
			this.psd_val = (this.psd_val + key).slice(0, 6);
			if (this.psd_val.length == 6) {
				this.write_psd = false;
				this.form.password = this.psd_val;
				if (this.submitType == 2) {
                    let data = {
                        id:this.$route.query.creditId,
                        passwd: this.form.password
                    }
                    Fetch('/loan/repayment',data).then(r => {
                        if(r.msg) {
                            Toast(r.msg)
                        }
                    }) 
				} else {
					this.setIniPwdSubmit();
				}

			}
		},
		onDelete() {
			this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
		},
         // 还款按钮
        sellerRegister() {
            this.write_psd = true
        },
        setIniPwdSubmit() {
			this.psd_val = "";
			Fetch('/user/setIniPwd', {
				password: this.form.password
			}).then((r) => {
				if (r.code == 1) {
                    Toast(r.info)
					setTimeout(() => {
						this.setPwd = false;
					}, 500);
				}else{
					Toast(r.msg)
				}
			});
		},
        setIniPwd() {
			this.submitType = 2;
			this.write_psd = true;
		}
    }
}
</script>

<style lang="scss" scoped>
.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
}
.loan_wrap {
    padding-top:44px;
    .form {
        margin:15px auto;
        width: 90%;
        height:fit-content;
    }
    .item {
        height: fit-content;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 4px;

        .t {
            display: flex;
            align-items: center;
            width: 100%;
            height: 30px;
            .people {
                width: 23px;
                height: 20px;
            }

            img {
                width: 100%;
                height: 100%;
            }
        }

        input {
            width:100%;
            height:48px;
            border:1px solid #F2F3F5;
            margin-bottom: 3px;
            padding:0 10px;
            border-radius:6px;
        }
    }
    .bottom {
        width:90%;
        height:46px;
        margin:0 auto;
        display:flex;
        align-items:center;
        justify-content: center;
        background:#F89900;
        border-radius:6px;
        .button {
            width:100%;
            height:100%;
            color:#fff;
            font-size:16px;
        }
    }
}
.keybord_box {
	height: 250px;
	background-color: #F0F0F0;
	margin-top: 35px;
	padding: 24px 12px 0 12px;
	margin: 0 auto;
	display: flex;
	justify-content: center;

	.keybord {
		width: 361px;
		margin: 24px auto 0 atuo;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		text-align: center;

		.key_item {
			width: 115px;
			height: 44px;
			line-height: 44px;
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 6px;
			background: rgba(255, 255, 255, 1);
			border-radius: 3px;

			&.no_bg {
				background: none;
			}

			&.x {
				color: #757880;
				font-weight: bold;
			}
		}
	}
}
</style>